import { ChevronRight, Download, ForwardToInbox, Search } from '@mui/icons-material'
import {
  Box,
  CircularProgress,
  Icon,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material'
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress'
import AdxInput from 'components/custom/AdxInput'
import DashboardContainer from 'components/smart/dashboard-container/DashboardContainer'
import React, { useEffect, useMemo, useState } from 'react'
import HistoryHeader from '../components/HistoryHeader'
import StatutoryTable from '../components/StatutoryTable'
import SelectEmployeeModal from 'module/payroll/global-components/SelectEmployeeModal'
import TotalSummary from 'module/payroll/global-components/TotalSummary'
import AdxInfoModal from 'components/reusable/modal/AdxInfoModal'
import { useMutation, useQuery } from 'react-query'
import {
  downloadAllPayslip,
  downloadSelectedEmployeePayslip,
  getEisTextFile,
  getMaybankEisTextFile,
  getEpfCsvFile,
  getMaybankEpfTextFile,
  getMaybankSocsoTextFile,
  getMaybankTaxTextFile,
  getHrdfReport,
  getMtdTextFile,
  getSocsoTextFile,
  getUploadedPayslip,
  recalculateAndRegeneratePayslip,
  sendAllPayslip,
  sendSelectedEmployeePayslip,
} from 'services/api/modules/payroll/payroll-history'
import { retrieveEmployeeData } from 'services/api/modules/payroll/payroll-view'
import { retrieveSummaryData } from 'services/api/modules/payroll/payroll-summary'
import { PayrollSummaryTableHeader } from '../../payroll-summary/components/PayrollSummaryTableHeader'
import SummaryDetails from '../../payroll-summary/components/SummaryDetails'
import Bugsnag from '@bugsnag/js'
import AdxButton from 'components/custom/AdxButton'
import AdxSortTable from 'components/reusable/table/AdxSortTable'
import { useNavigate } from 'react-router-dom'
import SnackbarRecruitment from 'module/recruitment/reusable/SnackbarRecruitment'
import { protectedPollingInterval } from 'services/session/queryPolicy'
import { downloadResponseFile } from 'services/helper/fileDownload'

const PayrollHistoryReport = ({ timeId }) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  const [errorSnackbarOpen, setErrorSnackbarOpen] = useState(false)
  const [errorSnackbarMessage, setErrorSnackbarMessage] = useState('')

  const {
    data: retrieveData,
    isLoading: loadingData,
    refetch: refetchRetrieveData,
  } = useQuery(['retrieveEmployeeData', timeId], async () => retrieveEmployeeData(timeId))

  const {
    data: retrieveSummary,
    isLoading: loadingSummary,
    refetch: refetchRetrieveSummary,
  } = useQuery(['retrieveSummaryData', timeId], async () => retrieveSummaryData({ time_id: timeId }))

  const [payrollData, setPayrollData] = useState()
  const [employeeDetails, setEmployeeDetails] = useState([])
  const [summaryData, setSummaryData] = useState([])
  const [isDownloadAll, setIsDownloadAll] = useState(false)
  const [isSendingAll, setIsSendingAll] = useState(false)

  useEffect(() => {
    if (retrieveData) {
      const employeeData = retrieveData?.data?.slice().sort((a, b) => (a.status > b.status ? -1 : 1))
      setEmployeeDetails(employeeData || [])
      setPayrollData(retrieveData)
    }
  }, [retrieveData])

  useEffect(() => {
    if (retrieveSummary) {
      setSummaryData(retrieveSummary?.data || [])
    }
  }, [retrieveSummary])

  const [keywords, setKeywords] = useState('')
  const [filteredEmployee, setFilteredEmployee] = useState([])

  useEffect(() => {
    const arr = employeeDetails.filter((item) => {
      if (keywords === '') return item
      if (item.name.toLowerCase().includes(keywords.toLowerCase())) return item
      return null
    })
    setFilteredEmployee(arr)
  }, [keywords, employeeDetails])

  const columnHeader = useMemo(() => PayrollSummaryTableHeader, [])

  const [drawerState, setDrawerState] = useState({ right: false })
  const [employeeDetail, setEmployeeDetail] = useState({})
  const [regenerateModalOpen, setRegenerateModalOpen] = useState(false)
  const [regenerateScope, setRegenerateScope] = useState('employee')

  const handleDrawer = (anchor, open) => () => {
    setDrawerState((prev) => ({ ...prev, [anchor]: open }))
  }

  const viewDetails = (details) => {
    setDrawerState((prev) => ({ ...prev, right: true }))
    setEmployeeDetail(details)
  }

  const [uploadedPayslip, setUploadedPayslip] = useState()
  const [uploadingPayslip, setUploadingPayslip] = useState(false)

  const { refetch: refetchUploadPayslip } = useQuery(
    ['uploadPayslip', timeId],
    () => getUploadedPayslip(timeId),
    {
      enabled: Boolean(timeId),
      refetchInterval: protectedPollingInterval(() => (uploadingPayslip ? 2000 : false)),
      onSuccess: (res) => {
        const payslipStatus = res.data
        const pendingPayslipCount = Number(payslipStatus?.not_yet_update_payslip || 0)

        setUploadedPayslip(payslipStatus)
        setUploadingPayslip(Boolean(payslipStatus) && pendingPayslipCount !== 0)

        if (uploadingPayslip && pendingPayslipCount === 0) {
          refetchRetrieveData()
          refetchRetrieveSummary()
        }
      },
      onError: (error) => {
        if (error.status === 422) {
          console.log(error)
        } else {
          Bugsnag.notify(error.data)
        }
      },
    }
  )

  const { refetch: refetchSendAll } = useQuery(
    ['sendPayslipForAll', timeId],
    () => sendAllPayslip(timeId),
    {
      enabled: false,
      onSuccess: () => {
        alert('Successfully send the payslip to all employees!')
        setIsSendingAll(false)
      },
      onError: (error) => {
        setIsSendingAll(false)
        if (error.status === 422) {
          console.log(error)
        } else {
          Bugsnag.notify(error.data)
        }
      },
    }
  )

  const handleSendAll = () => {
    setIsSendingAll(true)
    refetchSendAll()
  }

  const { refetch: refetchDownloadAll } = useQuery(
    ['downloadPayslipForAll', timeId],
    () => downloadAllPayslip(timeId),
    {
      enabled: false,
      onSuccess: (res) => {
        const downloadZipFilename = `payslip_${payrollData?.month}${payrollData?.year}.zip`
        downloadResponseFile(res, {
          fileName: downloadZipFilename,
          contentType: 'application/zip',
          successMessage: 'All payslips downloaded.',
        })
        if (res.data) {
          setIsDownloadAll(false)
        }
      },
      onError: (error) => {
        setIsDownloadAll(false)
        if (error.status === 422) {
          console.log(error)
        } else {
          Bugsnag.notify(error.data)
        }
      },
    }
  )

  const handleDownloadAll = () => {
    setIsDownloadAll(true)
    refetchDownloadAll()
  }

  const createBlobDownload = (res, type = 'text/plain') => {
    downloadResponseFile(res, {
      fileName: 'payroll_download.txt',
      contentType: type,
      successMessage: 'Payroll file downloaded.',
    })
  }

  const { refetch: refetchEpfCsvFile } = useQuery(['epfCsvFile', timeId], () => getEpfCsvFile(timeId), {
    enabled: false,
    onSuccess: (res) => createBlobDownload(res),
    onError: (error) => {
      if (error.status === 422) {
        console.log(error)
      } else {
        Bugsnag.notify(error.data)
      }
    },
  })

  const downloadEpf = () => refetchEpfCsvFile()

  const { refetch: refetchEisTextFile } = useQuery(['eisTextFile', timeId], () => getEisTextFile(timeId), {
    enabled: false,
    onSuccess: (res) => createBlobDownload(res, 'text/plain'),
    onError: (error) => {
      if (error.status === 422) {
        console.log(error)
      } else {
        Bugsnag.notify(error.data)
      }
    },
  })

  const downloadEis = () => refetchEisTextFile()

  const handleMaybankError = (error, fallbackMessage) => {
    if (error.response?.status === 404 || error.response?.status === 422) {
      const errorData = error.response?.data
      if (errorData?.data && Array.isArray(errorData.data)) {
        const errorMessages = errorData.data.join('\n')
        const fullMessage = `${errorData.message || fallbackMessage}\n\n${errorMessages}`
        setErrorSnackbarMessage(fullMessage)
        setErrorSnackbarOpen(true)
      } else {
        setErrorSnackbarMessage(errorData?.message || fallbackMessage)
        setErrorSnackbarOpen(true)
      }
    } else {
      Bugsnag.notify(error.data)
      setErrorSnackbarMessage('An unexpected error occurred. Please try again.')
      setErrorSnackbarOpen(true)
    }
  }

  const { refetch: refetchMaybankEisTextFile } = useQuery(
    ['maybankEisTextFile', timeId],
    () => getMaybankEisTextFile(timeId),
    {
      enabled: false,
      onSuccess: (res) => createBlobDownload(res, 'text/plain'),
      onError: (error) => handleMaybankError(error, 'Error generating Maybank EIS file'),
    }
  )

  const downloadMaybankEis = () => refetchMaybankEisTextFile()

  const { refetch: refetchMaybankEpfTextFile } = useQuery(
    ['maybankEpfTextFile', timeId],
    () => getMaybankEpfTextFile(timeId),
    {
      enabled: false,
      onSuccess: (res) => createBlobDownload(res, 'text/plain'),
      onError: (error) => handleMaybankError(error, 'Error generating Maybank EPF file'),
    }
  )

  const downloadMaybankEpf = () => refetchMaybankEpfTextFile()

  const { refetch: refetchMaybankSocsoTextFile } = useQuery(
    ['maybankSocsoTextFile', timeId],
    () => getMaybankSocsoTextFile(timeId),
    {
      enabled: false,
      onSuccess: (res) => createBlobDownload(res, 'text/plain'),
      onError: (error) => handleMaybankError(error, 'Error generating Maybank SOCSO file'),
    }
  )

  const downloadMaybankSocso = () => refetchMaybankSocsoTextFile()

  const { refetch: refetchMaybankTaxTextFile } = useQuery(
    ['maybankTaxTextFile', timeId],
    () => getMaybankTaxTextFile(timeId),
    {
      enabled: false,
      onSuccess: (res) => createBlobDownload(res, 'text/plain'),
      onError: (error) => handleMaybankError(error, 'Error generating Maybank TAX file'),
    }
  )

  const downloadMaybankTax = () => refetchMaybankTaxTextFile()

  const { refetch: refetchSocsoTextFile } = useQuery(
    ['socsoTextFile', timeId],
    () => getSocsoTextFile(timeId),
    {
      enabled: false,
      onSuccess: (res) => createBlobDownload(res, 'text/plain'),
      onError: (error) => {
        if (error.status === 422) {
          console.log(error)
        } else {
          Bugsnag.notify(error.data)
        }
      },
    }
  )

  const downloadSocso = () => refetchSocsoTextFile()

  const { refetch: refetchMtdTextFile } = useQuery(
    ['mtdTextFile', timeId],
    () => getMtdTextFile(timeId),
    {
      enabled: false,
      onSuccess: (res) => createBlobDownload(res, 'text/plain'),
      onError: (error) => {
        if (error.status === 422) {
          console.log(error)
        } else {
          Bugsnag.notify(error.data)
        }
      },
    }
  )

  const downloadLhdn = () => refetchMtdTextFile()

  const { refetch: refetchHrdfReport } = useQuery(
    ['hrdfReport', timeId],
    () => getHrdfReport(timeId),
    {
      enabled: false,
      onSuccess: (res) =>
        downloadResponseFile(res, {
          fileName: 'hrdf_report',
          contentType: res.headers['content-type'],
          successMessage: 'HRDF report downloaded.',
        }),
      onError: (error) => {
        if (error.status === 422) {
          console.log(error)
        } else {
          Bugsnag.notify(error.data)
        }
      },
    }
  )

  const downloadHrdf = () => refetchHrdfReport()

  const { mutate: regeneratePayslip, isLoading: regeneratingPayslip } =
    useMutation(recalculateAndRegeneratePayslip, {
      onSuccess: () => {
        setRegenerateModalOpen(false)
        setUploadingPayslip(true)
        refetchRetrieveData()
        refetchRetrieveSummary()
        refetchUploadPayslip()
      },
      onError: (error) => {
        const message =
          error?.response?.data?.message ||
          error?.data?.message ||
          'Unable to regenerate payslip. Please try again.'

        setErrorSnackbarMessage(message)
        setErrorSnackbarOpen(true)

        if (error.status !== 422 && error?.response?.status !== 422) {
          Bugsnag.notify(error.data || error)
        }
      },
    })

  const handleRegenerateEmployeePayslip = () => {
    if (!employeeDetail?.id) return
    setRegenerateScope('employee')
    setRegenerateModalOpen(true)
  }

  const confirmRegenerateEmployeePayslip = () => {
    if (regenerateScope === 'employee' && !employeeDetail?.id) return

    regeneratePayslip({
      time_id: timeId,
      data:
        regenerateScope === 'all'
          ? {
              preserve_manual_statutory: false,
            }
          : {
              staff_ids: [employeeDetail.id],
              preserve_manual_statutory: false,
            },
    })
  }

  const regenerateAllPayslips = () => {
    regeneratePayslip({
      time_id: timeId,
      data: {
        preserve_manual_statutory: false,
      },
    })
  }

  const regenerateSelectedPayslips = (data) => {
    const staffIds = data?.selected_employee?.map((employee) => employee.employee_id) || []

    regeneratePayslip({
      time_id: timeId,
      data: {
        staff_ids: staffIds,
        preserve_manual_statutory: false,
      },
    })
  }

  const { mutate: downloadPayslip, isLoading: loadingDownloadSelectedPayslip } = useMutation(
      downloadSelectedEmployeePayslip,
    {
      onSuccess: (res) => {
        downloadResponseFile(res, {
          fileName: `payslip_${retrieveData?.month}${retrieveData?.year}.zip`,
          contentType: 'application/zip',
          successMessage: 'Selected payslips downloaded.',
        })
      },
      onError: (error) => {
        if (error.status === 422) {
          console.log(error)
        } else {
          Bugsnag.notify(error.data)
        }
      },
    }
  )

  const downloadSelectedPayslip = (data) => {
    downloadPayslip({ time_id: timeId, data })
  }

  const { mutate: sendPayslip, isLoading: loadingSendSelectedPayslip } = useMutation(
    sendSelectedEmployeePayslip,
    {
      onSuccess: () => {
        alert('Succesfully send to selected employees')
      },
      onError: (error) => {
        if (error.status === 422) {
          console.log(error)
        } else {
          Bugsnag.notify(error.data)
        }
      },
    }
  )

  const sendSelectedPayslip = (data) => {
    sendPayslip({ time_id: timeId, data })
  }

  const navigate = useNavigate()

  const progressValue =
    uploadedPayslip?.total_payslip > 0
      ? (uploadedPayslip?.updated_payslip / uploadedPayslip?.total_payslip) * 100
      : 0

  return (
    <DashboardContainer
      headerTitle={
        <Box
          sx={{
            display: 'flex',
            gap: 0.5,
            alignItems: 'center',
            flexWrap: 'wrap',
          }}
        >
          <Typography
            onClick={() => navigate(-1)}
            sx={{ cursor: 'pointer', color: 'alternate.main' }}
          >
            Payroll History
          </Typography>
          <ChevronRight sx={{ color: 'light-gray-text.main' }} />
          <Typography>{`${payrollData?.month || ''} ${payrollData?.year || ''}`}</Typography>
        </Box>
      }
    >
      <Box
        sx={{
          height: {
            xs: 'calc(100vh - 140px)',
            sm: 'calc(100vh - 150px)',
            md: 'calc(100vh - 160px)',
          },
          overflowY: 'auto',
          overflowX: 'hidden',
          WebkitOverflowScrolling: 'touch',
          pr: { xs: 0.5, sm: 1 },
          display: 'flex',
          flexDirection: 'column',
          gap: 4,
          width: '100%',
          minWidth: 0,
          pb: 3,
        }}
      >
        <HistoryHeader
          payrollData={payrollData}
          time_id={timeId}
        />

        <TotalSummary
          totalSum={summaryData}
          filteredEmployee={employeeDetails}
          timeStamp={payrollData}
          loadingSummary={loadingSummary}
        />

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%', minWidth: 0 }}>
          <Typography variant="h4">Supporting document</Typography>

          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', lg: 'row' },
              gap: 2,
              width: '100%',
              minWidth: 0,
            }}
          >
            <Box
              sx={{
                width: { xs: '100%', lg: '66.6667%' },
                minWidth: 0,
                bgcolor: 'white.main',
              }}
            >
              <Box sx={{ display: 'flex', flexDirection: 'column', rowGap: 2 }}>
                <StatutoryTable
                  total_amount={summaryData}
                  downloadEpf={downloadEpf}
                  downloadEis={downloadEis}
                  downloadMaybankEis={downloadMaybankEis}
                  downloadMaybankEpf={downloadMaybankEpf}
                  downloadMaybankSocso={downloadMaybankSocso}
                  downloadMaybankTax={downloadMaybankTax}
                  downloadSocso={downloadSocso}
                  downloadLhdn={downloadLhdn}
                  downloadHrdf={downloadHrdf}
                  time_id={timeId}
                />
              </Box>
            </Box>

            <Box
              sx={{
                width: { xs: '100%', lg: '33.3333%' },
                minWidth: 0,
                bgcolor: 'white.main',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-evenly',
                alignItems: 'center',
                p: 3,
                border: 1,
                borderColor: 'gray-line.main',
                borderRadius: '4.5px',
              }}
            >
              <Box display="flex" flexDirection="column" alignItems="center">
                <Box
                  bgcolor="alternate.light"
                  width="65px"
                  height="65px"
                  borderRadius="50%"
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                >
                  <Icon sx={{ color: 'alternate.main' }}>feed</Icon>
                </Box>

                <Typography variant="h4" sx={{ my: 2, textAlign: 'center' }}>
                  Payslip
                </Typography>

                <Typography textAlign="center" color="light-gray-text.main">
                  {uploadingPayslip
                    ? `You’ll be able to download or send payslip to employees once it’s completely generated`
                    : `Automatically generate and share payslips to employees`}
                </Typography>
              </Box>

              {uploadingPayslip ? (
                <Box
                  width="100%"
                  sx={{
                    bgcolor: 'default-background.main',
                    p: 2,
                    borderRadius: 2,
                    mt: 3,
                  }}
                >
                  <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography color="light-gray-text.main">Generating...</Typography>
                    <Typography variant="subtitle">
                      {uploadedPayslip ? `${Math.round(progressValue)}%` : '0%'}
                    </Typography>
                  </Box>

                  <LinearProgress
                    variant="determinate"
                    value={progressValue}
                    sx={{
                      borderRadius: '10px',
                      height: '14px',
                      mt: 1,
                      [`& .${linearProgressClasses.bar}`]: {
                        borderRadius: '10px',
                        backgroundColor: 'alternate.main',
                      },
                      [`&.${linearProgressClasses.colorPrimary}`]: {
                        backgroundColor: 'white.main',
                      },
                    }}
                  />
                </Box>
              ) : (
                <Box width="100%" sx={{ mt: 4 }} display="flex" flexDirection="column" rowGap={1}>
                  <SelectEmployeeModal
                    handleAllEmployees={regenerateAllPayslips}
                    loadingAllStatus={regeneratingPayslip}
                    handleSelectedEmployees={regenerateSelectedPayslips}
                    loadingSelectedStatus={regeneratingPayslip}
                    item="Regenerate"
                    itemDescription="Regenerate payslip for:"
                    payrollData={retrieveData}
                    time_id={timeId}
                    details={retrieveData?.data}
                    titleHeader={`${payrollData?.month} ${payrollData?.year}`}
                    descHeader={'Regenerate payslips'}
                    iconHeader={<Icon>autorenew</Icon>}
                  >
                    <Typography
                      component="span"
                      sx={{
                        alignSelf: 'center',
                        display: 'block',
                        mb: 1,
                        color: regeneratingPayslip ? 'light-gray-text.main' : 'alternate.main',
                        cursor: regeneratingPayslip ? 'default' : 'pointer',
                        textAlign: 'center',
                        textDecoration: 'underline',
                        textUnderlineOffset: '2px',
                      }}
                    >
                      Regenerate payslips
                    </Typography>
                  </SelectEmployeeModal>

                  <SelectEmployeeModal
                    handleAllEmployees={handleSendAll}
                    loadingAllStatus={isSendingAll}
                    handleSelectedEmployees={sendSelectedPayslip}
                    loadingSelectedStatus={loadingSendSelectedPayslip}
                    item="Send"
                    itemDescription="Send payslip to:"
                    payrollData={retrieveData}
                    time_id={timeId}
                    details={retrieveData?.data}
                    titleHeader={`${payrollData?.month} ${payrollData?.year}`}
                    descHeader={'Send payslip to employee via Email'}
                    iconHeader={<ForwardToInbox />}
                  >
                    <AdxButton variant="contained" fullWidth>
                      Send via email
                    </AdxButton>
                  </SelectEmployeeModal>

                  <SelectEmployeeModal
                    handleAllEmployees={handleDownloadAll}
                    loadingAllStatus={isDownloadAll}
                    handleSelectedEmployees={downloadSelectedPayslip}
                    loadingSelectedStatus={loadingDownloadSelectedPayslip}
                    item="Download"
                    itemDescription="Download payslip of:"
                    payrollData={retrieveData}
                    time_id={timeId}
                    details={retrieveData?.data}
                    titleHeader={`${payrollData?.month} ${payrollData?.year}`}
                    descHeader={'Download payslip as pdf'}
                    iconHeader={<Download />}
                  >
                    <AdxButton variant="ghost" fullWidth>
                      Download payslip
                    </AdxButton>
                  </SelectEmployeeModal>
                </Box>
              )}
            </Box>
          </Box>
        </Box>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, minWidth: 0 }}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' },
              justifyContent: 'space-between',
              alignItems: { xs: 'stretch', sm: 'center' },
              gap: 2,
            }}
          >
            <Typography variant="h4">Employee</Typography>

            <AdxInput
              type="standard"
              placeholder="Search employee name"
              onChange={(e) => setKeywords(e.target.value)}
              startAdornment={<Search color="light-gray-text" sx={{ mr: 1 }} />}
              sx={{
                width: { xs: '100%', sm: '320px', md: '420px', lg: '500px' },
                maxWidth: '100%',
                '& .MuiInputBase-root': {
                  minHeight: '45px',
                  width: '100%',
                  outlineColor: '#E5E5E5',
                  bgcolor: 'white.main',
                },
              }}
            />
          </Box>

          <Box
            sx={{
              border: 1,
              borderColor: 'gray-line.main',
              borderRadius: 2,
              width: '100%',
              overflow: 'hidden',
              bgcolor: 'white.main',
              minWidth: 0,
            }}
          >
            {loadingData ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
                <CircularProgress color="alternate" size={60} />
              </Box>
            ) : (
              <>
                <AdxSortTable
                  data={filteredEmployee}
                  column={columnHeader}
                  allColumnSorted={false}
                  stickyHeader="stickyHeader"
                  divClick={true}
                  onClick={viewDetails}
                  height={isMobile ? '360px' : '420px'}
                />

                <SummaryDetails
                  drawerState={drawerState}
                  handleDrawer={handleDrawer}
                  details={employeeDetail}
                  time_id={timeId}
                  sendPayslip={true}
                  uploadingPayslip={uploadingPayslip}
                  regeneratePayslip={handleRegenerateEmployeePayslip}
                  regeneratingPayslip={regeneratingPayslip}
                />
              </>
            )}
          </Box>
        </Box>
      </Box>

      {errorSnackbarOpen && (
        <SnackbarRecruitment
          autoHideDuration={10000}
          status="error"
          TransitionComponent="slide"
          message={errorSnackbarMessage}
          open={errorSnackbarOpen}
          handleClose={() => setErrorSnackbarOpen(false)}
        />
      )}

      <AdxInfoModal
        open={regenerateModalOpen}
        onClose={() => setRegenerateModalOpen(false)}
        muiIcon="warning"
        iconColor="warning.main"
        title="Regenerate payslip?"
        subtitle={`This will recalculate payroll and regenerate the payslip for ${
          employeeDetail?.name || 'this employee'
        }.`}
        footerButtons
        firstBtnLabel="Regenerate"
        firstBtnHandle={confirmRegenerateEmployeePayslip}
        firstBtnLoading={regeneratingPayslip}
        secondBtnLabel="Cancel"
        secondBtnHandle={() => setRegenerateModalOpen(false)}
        secondBtnDisabled={regeneratingPayslip}
      />
    </DashboardContainer>
  )
}

export default PayrollHistoryReport
